module.exports = __webpack_public_path__ + "img/xiaocxhenxu.b8698c31.png";